import PageNotFound from "../components/common/PageNotFound";
import AIData from "../components/home/ai-data/AIData";
import AIInference from "../components/home/ai-inference/AIInference";
import AIModel from "../components/home/ai-model/AIModel";
import AIPrediction from "../components/home/ai-prediction/AIPrediction";
import AIRoadMap from "../components/home/ai-roadmap/AIRoadMap";
import AITraining from "../components/home/ai-training/AITraining";
import AIValue from "../components/home/ai-value/AIValue";
import AIPipeline from "../components/home/ai-pipeline/AIPipeline";
import TemplateForm from "../components/home/ai-pipeline/TemplateForm";
import BusinessOverview from "../components/home/business-overview/BusinessOverview";
import CreateAgent from "../components/home/create-agent/CreateAgent";
import Home from "../components/home/Home";
import ProfilePage from "../components/home/user/ProfilePage";
import UserManagement from "../components/home/user/UserManagement";
import constant from "../helper/constant";
import LoginPage from "../pages/auth/LoginPage";
import UnsignedPage from "../pages/auth/UnsignedPage";
import UnsignedReportPage from "../pages/auth/UnsignedReportPage";
import CreateOrgPage from "../pages/home/CreateOrgPage";
import DashboardPage from "../pages/home/DashboardPage";
import Callback from "./../pages/home/Callback";
import AIWorkflow from "../components/home/ai-workflow/AIWorkflow";
import Business360Page from "../pages/home/Business360Page";
import Supplier360Page from "../pages/home/Supplier360Page";
import Competitor360Page from "../pages/home/Competitor360Page";
import Complementor360Page from "../pages/home/Complimentor360Page";
import Customer360Page from "../pages/home/Customer360Page";
import Summary360Table from "../pages/home/components/common/Summary360Table";
import PreditionDashboard from "../pages/home/components/PredictionDashboard";
import AIRecommendation from "../components/home/ai-recommendation/AIRecommendation";
import CustomViewList from "../pages/home/components/CustomViewList";
import CustomDashboardView from "../components/home/dashboard/CustomDashboardView";
import ImpartAI from "../pages/home/components/impart-ai/AIImpart";
import ImpartDashboard from "../pages/home/components/impart-ai/ImpartDashboard";
import ImpartDetail from "../pages/home/components/impart-ai/ImpartDetail";

const authRoutes = [
  {
    path: ``,
    element: <UnsignedPage />,
  },
  {
    path: `${constant.PAGES.AUTH.VALUE_CALCULATOR_REPORT}`,
    element: <UnsignedReportPage />,
  },
  {
    path: `${constant.PAGES.AUTH.LOGIN}`,
    element: <LoginPage />,
  },
  {
    path: `*`,
    element: <LoginPage />,
  },
];

const appRoutes = [
  {
    path: ``,
    element: <DashboardPage />,
    children: [
      {
        path: ``,
        element: <AIRecommendation />,
      },
      {
        path: `home`,
        element: <Home />,
      },
      {
        path: `${constant.PAGES.HOME.BUSINESS_OVERVIEW}`,
        element: <BusinessOverview />,
      },
      {
        path: `${constant.PAGES.HOME.PROFILE}`,
        element: <ProfilePage />,
      },
      {
        path: `${constant.PAGES.HOME.USER_MANAGEMENT}`,
        element: <UserManagement />,
      },
      {
        path: `${constant.PAGES.HOME.AI_TEMPLATE}`,
        element: <TemplateForm />,
      },
      {
        path: `${constant.PAGES.HOME.AI_PIPELINE}/:id`,
        element: <AIPipeline />,
      },
      {
        path: `${constant.PAGES.HOME.AI_VALUE}/:id`,
        element: <AIValue />,
      },
      {
        path: `${constant.PAGES.HOME.AI_ROADMAP}/:id`,
        element: <AIRoadMap />,
      },
      {
        path: `${constant.PAGES.HOME.AI_DATA}/:id`,
        element: <AIData />,
      },
      {
        path: `${constant.PAGES.HOME.AI_MODEL}/:id`,
        element: <AIModel />,
      },
      {
        path: `${constant.PAGES.AI_PREDICTION}/:id/*`,
        element: <AIPrediction />,
      },
      {
        path: `${constant.PAGES.HOME.AI_TRAINING}`,
        element: <AITraining />,
      },
      {
        path: `${constant.PAGES.HOME.AI_CREATE_AGENT}`,
        element: <CreateAgent />,
      },
      {
        path: `${constant.PAGES.HOME.AI_CREATE_AGENT}/:agent`,
        element: <CreateAgent />,
      },
      {
        path: `${constant.PAGES.INFERENCE_DASHBOARD}`,
        element: <AIInference />,
      },
      {
        path: `${constant.PAGES.CUSTOM_DASHBOARD_VIEW}`,
        element: <CustomDashboardView />
      },
      {
        path: `${constant.PAGES.HOME.AI_WORKFLOW}`,
        element: <AIWorkflow />,
      },
      {
        path: `${constant.PAGES.HOME.AI_WORKFLOW}/:id`,
        element: <AIWorkflow />,
      },
      {
        path: `${constant.PAGES.HOME.CUSTOM_VIEW_LIST}`,
        element: <CustomViewList />,
      }
    ],
  },
  {
    path: `${constant.PAGES.CREATE_ORG}`,
    element: <CreateOrgPage />,
  },
  {

    path: `${constant.PAGES.BUSINESS_360}`,
    element: <Business360Page />
  },
  {

    path: `${constant.PAGES.SUMMARY_360}`,
    element: <Summary360Table />
  },
  {

    path: `${constant.PAGES.SUPPLIER_VIEW}`,
    element: <Supplier360Page />
  },
  {

    path: `${constant.PAGES.COMPETITOR_VIEW}`,
    element: <Competitor360Page />
  },
  {

    path: `${constant.PAGES.COMPLEMENTOR_VIEW}`,
    element: <Complementor360Page />
  },
  {

    path: `${constant.PAGES.CUSTOMER_VIEW}`,
    element: <Customer360Page />
  },
  {
    path: `${constant.PAGES.PREDICTION_VIEW}`,
    element: <PreditionDashboard />
  },
  {
    path: `${constant.PAGES.IMPART_AI.IMPART_AI}`,
    element: <ImpartAI />,
    children: [
      {
        path: ``,
        element: <ImpartDashboard />
      },
      {
        path: constant.PAGES.IMPART_AI.IMPART_AI_DETAIL,
        element: <ImpartDetail />
      }
    ]
  },
  {
    path: `${constant.PAGES.ZOHO_CALLBACK}`,
    element: <Callback />,
  },
  {
    path: `*`,
    element: <PageNotFound />,
  },
];

const viewerRoutes = [
  {
    path: ``,
    element: <Business360Page />,
  },
];
export { authRoutes, appRoutes, viewerRoutes };
